export const amount = (value, currency) => new Intl.NumberFormat('es-CL', {
  style: 'currency', currency: currency || 'CLP', maximumFractionDigits: 0
}).format(Number(value || 0));
export const count = (value) => Number(value || 0).toLocaleString('es-CL');
export const percentage = (value) => Number(value || 0).toLocaleString('es-CL', {
  maximumFractionDigits: 2
}) + '%';

export function WorkbenchHead({ number, title, description }) {
  return <div className="mgw-head">
    <div><p>{number} · Centro de decisiones</p><h2>{title}</h2></div>
    <span>{description}</span>
  </div>;
}

